import { FilterFnOption } from "@tanstack/react-table";
import { TIsolation, TLeakTestPack } from "../../../lib/types";
import { TIsolationFilters } from "../../organisms/IsolationFilter/IsolationFiltersModal";
import { getIsolationOptions, getLabelForIsolationStatus } from "../../organisms/JobFiltersModal/JobFiltersModal.util";
import { ISOLATION_DRAWING_STATUS_ENUM, LEAK_TEST_PACK_TYPE_ENUM } from "../../../lib/constants/dbConstants";
import { TLeakTestPackFilters } from "../../organisms/LeakTestPackFiltersModal/LeakTestPackFiltersModal";

export const leakTestPacksGlobalFilterFn: FilterFnOption<TLeakTestPack> = (
  row,
  _columnId,
  { filters, searchString }: { filters: TLeakTestPackFilters; searchString: string }
) => {
  const { original } = row;

  if (
    // Search string doesn't match, skip the rows
    searchString &&
    !JSON.stringify(original).toLowerCase().includes(searchString.toLowerCase())
  ) {
    return false;
  }

  //filtering event
  if (filters.event) {
    const eventValue = original.tarJobs?.[0]?.tarEvent?.eventDescription || ''; //leak Tests 1:M jobs in same event
    if (
      // event doesn't match, skip the rows
      filters.event.length > 0 &&
      !(eventValue && filters.event.includes(eventValue))
    )
      return false;
  }
  //filtering drawing status
  if (filters.leakTestPackType) {
    const leakTestPackTypeValue = LEAK_TEST_PACK_TYPE_ENUM[original.leakTestPackType] || '';
    if (
      // drawing status doesn't match, skip the rows
      filters.leakTestPackType.length > 0 &&
      !(leakTestPackTypeValue && filters.leakTestPackType.includes(leakTestPackTypeValue))
    )
      return false;
  }
  //filtering packNumber, title and system number
  if (filters['trackPackNumber']) {
    const trackPackNumber = original?.trackPackNumber;
    if (
      // isolation numbers don't match, skip the rows
      filters['trackPackNumber'].length > 0 &&
      !(
        trackPackNumber &&
        filters.trackPackNumber.some((number) => trackPackNumber.toLowerCase()===number.toLowerCase())
      )
    )
      return false;
  }
  if (filters['systemNumber']) {
    const systemNumber = original?.systemNumber;
    if (
      // system numbers don't match, skip the rows
      filters['systemNumber'].length > 0 &&
      !(systemNumber && filters.systemNumber.some((system) => systemNumber.toLowerCase()===system.toLowerCase()))
    )
      return false;
  }
  if (filters['leakTestPackTitle']) {
    const leakTestPackTitle = original?.leakTestPackTitle;
    if (
      // titles don't match, skip the rows
      filters['leakTestPackTitle'].length > 0 &&
      !(
        leakTestPackTitle &&
        filters.leakTestPackTitle.some((title) => leakTestPackTitle.toLowerCase().includes(title.toLowerCase()))
      )
    )
      return false;
  }

  return true;
};